import EmpresaConfig from "./EmpresaConfig";

export default class EmpresaService {
	static setEmpresa(value, id) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = EmpresaConfig.endpoint;
				let response = await EmpresaConfig.APIConnector.post(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static updateEmpresa(id, value) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(value);
				let endpoint = EmpresaConfig.endpoint;
				let response = await EmpresaConfig.APIConnector.put(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static deleteEmpresa(empresaId, empresa) {
		return new Promise(async (resolve, reject) => {
			try {
				let body = JSON.stringify(empresa);
				let endpoint = EmpresaConfig.endpointDeleteEmpresas + "/" + empresaId;
				let response = EmpresaConfig.APIConnector.delete(endpoint, {
					body
				});
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
	static getEmpresaList(searchText, page, size) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = EmpresaConfig.endpoint + "?";
				if (searchText) {
					endpoint += "&searchText=" + searchText;
				}
				if (page && size) {
					endpoint += "&page=" + page + "&size=" + size;
				}
				let response = await EmpresaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static checkCuit(cuit) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = EmpresaConfig.endpointCheckCuit + "?cuit=" + cuit;
				let response = await EmpresaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static checkMail(mail) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = EmpresaConfig.endpointCheckMail + "?mail=" + mail;
				let response = await EmpresaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}

	static getByCuit(cuit) {
		return new Promise(async (resolve, reject) => {
			try {
				let endpoint = EmpresaConfig.endpointByCuit + "?cuit=" + cuit;
				let response = await EmpresaConfig.APIConnector.get(endpoint);
				resolve(response);
			} catch (error) {
				reject(error);
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/provider/Empresa/EmpresaService.js